import { render, staticRenderFns } from "./SubscriptionBoxOrderFraudReview.vue?vue&type=template&id=33cded80&scoped=true&lang=pug&"
import script from "./SubscriptionBoxOrderFraudReview.vue?vue&type=script&setup=true&lang=js&"
export * from "./SubscriptionBoxOrderFraudReview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SubscriptionBoxOrderFraudReview.vue?vue&type=style&index=0&id=33cded80&prod&lang=sass&scoped=true&"
import style1 from "./SubscriptionBoxOrderFraudReview.vue?vue&type=style&index=1&id=33cded80&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cded80",
  null
  
)

export default component.exports